import { Component, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import axios from "src/app/Service/axios";
import { Location } from '@angular/common';
import Map from 'ol/Map';
import View from 'ol/View';
import * as olProj from 'ol/proj';
import VectorLayer from 'ol/layer/Vector';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import Feature from 'ol/Feature';
import { Tile as TileLayer } from 'ol/layer';
import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import { Tile } from "ol/layer";
import { MapService } from "src/app/Service/map.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import "ol/ol.css";
import * as XLSX from 'xlsx';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import momentJalaali from "moment-jalaali";
import { DataService } from "src/app/Service/data.service";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import VectorSource from "ol/source/Vector";
import { ChartContext, ChartDataItem } from 'src/app/shared/chart/chart.models';
import { DashboardProChartKey } from './dashboardpro.models';
declare let $: any;

@Component({

  selector: 'app-dashboardpro',

  templateUrl: './dashboardpro.component.html',

  styleUrls: ['./dashboardpro.component.css']

})

export class DashboardproComponent implements OnInit {

  constructor(private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private el: ElementRef,
    private _location: Location,
    private mapService: MapService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private gurdService: GurdServiceService
  ) {

  }

  totalMileageChart: ChartContext = {
    type: 'bar', title: 'پیمایش کل دوره خودرو ها(km)', unit: 'km',
    zoom: true, data: [], loading: true,
  };

  entryExitMileageChart: ChartContext = {
    type: 'bar', title: 'پیمایش خودرو ها براساس ورود خروج', unit: 'km',
    zoom: true, data: [], loading: true,
  };

  dailyWorkingHoursChart: ChartContext = {
    type: 'line', title: 'جمع ساعت کارکرد روزانه', unit: 'ساعت',
    zoom: true, colors: ['#FF3333'], data: [], loading: true,
  };

  dailyMileageChart: ChartContext = {
    type: 'line', title: 'میزان پیمایش روزانه به (Km)', unit: 'km',
    zoom: true, colors: ['#FF3333'], data: [], loading: true,
  };

  repairCostChart: ChartContext = {
    type: 'bar', title: 'بیشترین هزینه تعمیرات (میلیون تومان)', unit: 'میلیون تومان',
    zoom: true, data: [], loading: true,
  };

  todayMileageChart: ChartContext = {
    type: 'bar', title: 'پیمایش امروز خودرو ها (km)', unit: 'km',
    zoom: true, data: [], loading: true,
  };

  mostExpensiveVehiclesChart: ChartContext = {
    type: 'bar', title: 'پر هزینه ترین خودرو ها (میلیون تومان)', unit: 'میلیون تومان',
    zoom: true, data: [], loading: true,
  };

  fuelConsumptionChart: ChartContext = {
    type: 'bar', title: 'پر مصرف ترین خودروها (لیتر در 100 کیلومتر)', unit: 'لیتر در 100 کیلومتر',
    zoom: true, data: [], loading: true,
  };

  serviceDueChart: ChartContext = {
    type: 'bar', title: 'سررسید سرویس های دوره ای (تعداد)', unit: 'تعداد',
    data: [], loading: true,
  };

  dataFrom: FormGroup = this.formBuilder.group({
    date: momentJalaali().subtract(1, 'jMonth').valueOf(),
  });

  dataTo: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  strSTime: FormControl = new FormControl("00:00");
  strETime: FormControl = new FormControl("23:59");
  modalData: any;
  iMobileDomain: number = -1;
  clusterModal: any;
  carNum: number = 0;
  domain: any;
  fileName = 'ExcelSheet.xlsx';
  carStatusData: any;
  JournalTypeData: any;
  onlinecar: number = 0;
  groupCar: any = [];
  filtersOpen = false;

  location: any = [51.3833554, 35.6770113];
  flon: any;
  flat: any;
  clusters: any;
  map: any = {};
  map2: any = {};
  map3: any = {};
  isDesktop: any;
  tiMobileType: any = -1;
  tabelArray: any = [];
  source: any;

  source2: any;

  source3: any;

  source4: any;

  vector: any;

  vector2: any;

  vector3: any;

  vector4: any;

  layers: any = [];

  layers2: any = [];

  layers3: any = [];

  layers4: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;
  ngOnInit(): void {
    this.otherService.Showspinner();
    this.isDesktop = this.deviceService.isDesktop();
    $('.clockpicker').clockpicker({
      donetext: 'top',
      align: 'top',
      autoclose: true,
    });

    setTimeout(() => {
      this.route.params.subscribe((params) => {
        // if (params['id']) {
        //   this.iMobileDomain = params['id'];

        // }
        if (this.dataService.dashbordData) {
          this.iMobileDomain = this.dataService.dashbordData.iMobileDomain
          this.tiMobileType = this.dataService.dashbordData.tiMobileType
          this.dataFrom.controls['date'].setValue(
            this.dataService.dashbordData.dataFrom || this.dataFrom.controls['date'].value
          );
          this.dataTo.controls["date"].setValue(this.dataService.dashbordData.dataTo);
          $("#Stime").val(this.dataService.dashbordData.stime);
          $("#Etime").val(this.dataService.dashbordData.etime);
        }
      })
    }, 300);

    setTimeout(async () => {
      try {

        this.source = new VectorSource({ wrapX: false });

        this.source2 = new VectorSource({ wrapX: false });

        this.source3 = new VectorSource({ wrapX: false });

        this.source4 = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({

          source: this.source,

        });

        this.vector2 = new VectorLayer({

          source: this.source2,

        });

        this.vector3 = new VectorLayer({

          source: this.source3,

        });

        this.vector4 = new VectorLayer({

          source: this.source4,

        });

        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' //

              }),

            })

          );
          this.layers2.push(

            new TileLayer({

              source: new XYZ({

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' //

              }),

            })

          );
          this.layers3.push(

            new TileLayer({

              source: new XYZ({

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' //

              }),

            })

          );
          this.layers4.push(

            new TileLayer({

              source: new XYZ({

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' //

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(
              new TileLayer({
                visible: false,
                preload: Infinity,
                source: new BingMaps({
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],
                }),

              }),
            );
            this.layers2.push(
              new TileLayer({
                visible: false,
                preload: Infinity,
                source: new BingMaps({
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],
                }),

              }),
            );
            this.layers3.push(
              new TileLayer({
                visible: false,
                preload: Infinity,
                source: new BingMaps({
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],
                }),

              }),
            );
            this.layers4.push(
              new TileLayer({
                visible: false,
                preload: Infinity,
                source: new BingMaps({
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                  imagerySet: styles[i],
                }),

              }),
            );

          }

          this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)

          this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)

          this.layers3.push(new TileLayer({ source: new OSM({}) }), this.vector3)

          this.layers4.push(new TileLayer({ source: new OSM({}) }), this.vector4)
        }
        this.map = new Map({
          target: "test",
          view: new View({
            zoom: 4,
            center: olProj.fromLonLat(this.location)
          }),
          layers: this.layers
        });
        this.map2 = new Map({
          target: "test2",
          view: new View({
            zoom: 4,
            center: olProj.fromLonLat(this.location)
          }),
          layers: this.layers2
        });
        this.map3 = new Map({
          target: "map",
          view: new View({
            zoom: 4,
            center: olProj.fromLonLat(this.location)
          }),
          layers: this.layers3
        });
        const results = await Promise.allSettled([
          this.getDomain(),
          this.getGroup(),
          this.loadChart('dailyMileageChart', 'Report_DailyKM', '20', true),
          this.loadChart('dailyWorkingHoursChart', 'Report_DailyTime', '32', true),
          this.loadChart('todayMileageChart', 'Report_DailyMobileKM', '33', true),
          this.loadChart('totalMileageChart', 'Report_TotalMobileKM', '34', true),
          this.loadChart('repairCostChart', 'Report_RepairMaintenanceRecord', '21'),
          this.loadChart('mostExpensiveVehiclesChart', 'Report_MostExpensiveCar', '25'),
          this.loadChart('serviceDueChart', 'Report_RepairMaintenanceCondition ', '27'),
          this.getCarTable(),
          this.loadChart('fuelConsumptionChart', 'Report_MobilesFullReport', '23'),
          this.loadChart('entryExitMileageChart', 'Report_TotalMobileKMBasiEnterance', '35', true),
          this.journalType(),
          this.clusterData(),
          this.clusterGasStation(),
        ]);
        if (results.some(result => result.status === 'rejected')) {
          this.notifyService.showError('دریافت بخشی از اطلاعات داشبورد با خطا مواجه شد. دوباره تلاش کنید.');
        }
      } finally {
        this.otherService.nonespinner();
      }
    }, 300);


  }
  ngAfterViewInit(): void {

  }
  search() {
    this.filtersOpen = false;
    this.dataService.dashbordData = {
      filtersOpen: this.filtersOpen,
      dataFrom: this.dataFrom.controls["date"].value,
      dataTo: this.dataTo.controls["date"].value,
      stime: $("#Stime").val(),
      etime: $("#Etime").val(),
      iMobileDomain: $("#domainDashbord").val(),
      tiMobileType: $("#carGroup").val(),
    }
    // Let the 300ms filter collapse finish before recreating the page.
    setTimeout(() => {
      this.reloadCurrentRoute();
    }, 350);
  }
  // changeDomain(val: any) {
  //   this.iMobileDomain = val.value;


  //   //this.router.navigateByUrl(`/dashbord/${val.value}`);

  //   setTimeout(() => {
  //     this.reloadCurrentRoute(val.value);
  //   }, 50);
  // }
  goBack() {
    this.router.navigateByUrl(`/`);;
  }
  private async loadChart(
    chartKey: DashboardProChartKey,
    api: string,
    sessionError: string,
    withDateRange = false,
  ): Promise<void> {
    this[chartKey] = { ...this[chartKey], loading: true, error: undefined };
    try {
      const model = {
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        iMobileDomain: this.iMobileDomain,
        tiMobileType: this.tiMobileType,
        ...(withDateRange ? {
          strSDate: this.dataFrom.controls['date'].value,
          strEDate: this.dataTo.controls['date'].value,
          strSTime: $('#Stime').val(),
          strETime: $('#Etime').val(),
        } : {}),
      };
      const response = await axios.post(api, model);
      const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (data?.ISSessionExpired === true || data?.ISessionExpired === true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login'], { queryParams: { error: sessionError } });
        return;
      }
      if (data?.iResult == 0) {
        this[chartKey] = { ...this[chartKey], error: data.strError || 'دریافت اطلاعات نمودار با خطا مواجه شد.' };
        this.notifyService.showError(data.strError);
        return;
      }
      if (!Array.isArray(data) || data.some(item =>
        !item || !(typeof item.X === 'string' || (typeof item.X === 'number' && Number.isFinite(item.X))) ||
        !(typeof item.Y === 'number' || (typeof item.Y === 'string' && item.Y.trim() !== '')) ||
        !Number.isFinite(Number(item.Y)) || Number(item.Y) < 0
      )) {
        throw new Error('Invalid dashboard chart data');
      }
      this[chartKey] = {
        ...this[chartKey],
        data: data.map(item => ({ name: String(item.X), value: Number(item.Y) })),
      };
    } catch (error) {
      this[chartKey] = { ...this[chartKey], error: 'دریافت اطلاعات نمودار با خطا مواجه شد. دوباره به روز رسانی کنید.' };
      throw error;
    } finally {
      this[chartKey] = { ...this[chartKey], loading: false };
    }
  }

  onRepairCostClick(item: ChartDataItem): void {
    this.fileName = 'نمودار بیشترین هزینه تعمیرات.xlsx';
    void this.carStatus(3, item.name);
  }

  onServiceDueClick(item: ChartDataItem): void {
    this.fileName = 'سررسید سرویس های دوره ای.xlsx';
    void this.carStatus(6, item.name);
  }

  getGroup = async () => {
    const resp = await axios.post(`GetMobileType`, {});
    this.groupCar = resp.data;
  };
  newOpenMap() {
    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'test',
      layers: [
        new TileLayer({
          source: new OSM({}),
        })
      ],
      view: new View({
        center: olProj.fromLonLat(this.location),
        zoom: 5,
      }),
    });

    //context menu
  }
  clusterData = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_MobileCluster`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '36' } });

      return;
    }
    this.clustersLayer(resParse);
  }
  clusterGasStation = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_GeoFullReport`, model);
    let resParse = JSON.parse(resp.data);
    if (resParse.iResult == 0) {
      this.notifyService.showError(resParse.strError);
      return;

    }
    if (resParse.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '37' } });

      return;
    }
    this.clustersLayer3(resParse);
  }
  journalType = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    const resp = await axios.post(`GetJournalType`, model);
    this.JournalTypeData = JSON.parse(resp.data);
    if (this.JournalTypeData.iResult == 0) {
      this.notifyService.showError(this.JournalTypeData.strError);
      return;

    }
    if (this.JournalTypeData.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '38' } });

      return;
    }
    model.tiJournalType = this.JournalTypeData[0].tiJournalType;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp2 = await axios.post(`Report_GeoJournal`, model);
    this.clustersLayer2(JSON.parse(resp2.data));
  }
  journalTypeChange = async (val: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.tiJournalType = val.value;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp2 = await axios.post(`Report_GeoJournal`, model);
    this.clustersLayer2(JSON.parse(resp2.data));

  }

  clustersLayer(data: any) {
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          // new Point (this.mapService.transformCoordinates2([
          //   data[i].dLongitude,
          //   data[i].dLatitude])

          // ),
          // data: data,
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].dLongitude,
            data[i].dLatitude])

          ),
          id_: data[i].strUnitId,
          data: {
            Id: data[i].strUnitId,
            strFullName: data[i].strFullName,
            strDate: data[i].strDate,
            strMobile: data[i].strMobile,
            strTime: data[i].strTime,
            strVehicleNo: data[i].strVehicleNo,
            strMobileType_strComment: data[i].strMobileType_strComment,


            // html: `${data[i].strFullName}`,
          },
        });
        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }
  clustersLayer2(data: any) {
    setTimeout(() => {
      this.map2.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map2.getEventPixel(e.originalEvent),
          this.map2
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    this.mapService.removeLayerByName("Cluster", this.map2);
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;
    setTimeout(() => {
      this.map2.getView().animate({
        zoom: this.map2.getView().getZoom() - 0.001,
        duration: 250
      })
      // Addfeatures to the cluster
      let addFeatures = (nb: any) => {
        var ext = this.map2.getView().calculateExtent(this.map2.getSize());
        var features = [];

        for (var i = 0; i < data.length; ++i) {
          features[i] = new Feature({
            // new Point (this.mapService.transformCoordinates2([
            //   data[i].dLongitude,
            //   data[i].dLatitude])

            // ),
            // data: data,
            type: 'removable',
            geometry: new Point(this.mapService.transformCoordinates2([
              data[i].fLon,
              data[i].fLat])

            ),
            id_: data[i].strUnitId,
            data: {
              Id: data[i].strUnitId,
              strFullName: data[i].strFullName,
              strDate: data[i].strDate,
              strMobile: data[i].strMobile,
              strTime: data[i].strTime,
              strVehicleNo: data[i].strVehicleNo,
              strMobileType_strComment: data[i].strMobileType_strComment,
              strJournalType_strComment: data[i].strJournalType_strComment,
              tiMaxSpeed: data[i].tiMaxSpeed,
              strComment: data[i].strComment,



              // html: `${data[i].strFullName}`,
            },
          });
          features[i].set("id", i);
        }
        clusterSource.getSource().clear();
        clusterSource.getSource().addFeatures(features);


      }

      // Style for the clusters
      var styleCache = {} as any;
      function getStyle(feature: any, resolution: any) {
        var size = feature.get("features").length;
        var style = styleCache[size];
        if (!style) {
          var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
          var radius = Math.max(8, Math.min(size * 0.75, 20));
          var dash = (2 * Math.PI * radius) / 6;
          var dashs = [0, dash, dash, dash, dash, dash, dash];
          style = styleCache[size] = new Style({
            image: new Circle({
              radius: radius,
              stroke: new Stroke({
                color: "rgba(" + color + ",0.5)",
                width: 15,
                lineDash: dashs,
                lineCap: "butt"
              }),
              fill: new Fill({
                color: "rgba(" + color + ",1)"
              })
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: "#fff"
              })
            })
          });
        }
        return style;
      }

      // Animated cluster layer
      var clusterLayer = new AnimatedCluster({
        name: "Cluster",
        source: clusterSource,
        animationDuration: 700,
        // Cluster style
        style: getStyle
      } as any);
      this.map2.addLayer(clusterLayer);
      // add 2000 features
      addFeatures(2000);

      var style1 = new Style({
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(128,0,0,0.8)",
            width: 2
          }),
          fill: new Fill({
            color: "rgba(128,0,0,0.8)"
          })
        }),
        // Draw a link beetween points (or not)
        stroke: new Stroke({
          color: "#fff",
          width: 1
        })
      });
      // Select interaction to spread cluster out and select features
      var selectCluster = new SelectCluster({
        // Point radius: to calculate distance between the features
        pointRadius: 7,
        animate: true,
        // Feature style when it springs apart
        featureStyle: function () {
          return [style1];
        },
        // selectCluster: false,	// disable cluster selection
        // Style to draw cluster when selected
        style: function (f, res) {
          var cluster = f.get("features");
          if (cluster.length > 1) {
            return getStyle(f, res);
          } else {
            return [
              new Style({
                image: new Circle({
                  stroke: new Stroke({
                    color: "rgba(0,0,192,0.5)",
                    width: 2
                  }),
                  fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                  radius: 5
                })
              })
            ];
          }
        }
      });
      this.map2.addInteraction(selectCluster);
    }, 50);



  }
  clustersLayer3(data: any) {
    setTimeout(() => {
      this.map3.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map3.getEventPixel(e.originalEvent),
          this.map3
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map3.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    this.mapService.removeLayerByName("Cluster", this.map3);
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;
    setTimeout(() => {
      this.map3.getView().animate({
        zoom: this.map3.getView().getZoom() - 0.001,
        duration: 250
      })
      // Addfeatures to the cluster
      let addFeatures = (nb: any) => {
        var ext = this.map3.getView().calculateExtent(this.map3.getSize());
        var features = [];

        for (var i = 0; i < data.length; ++i) {
          features[i] = new Feature({
            // new Point (this.mapService.transformCoordinates2([
            //   data[i].dLongitude,
            //   data[i].dLatitude])

            // ),
            // data: data,
            type: 'removable',
            geometry: new Point(this.mapService.transformCoordinates2([
              data[i].fLon,
              data[i].fLat])

            ),
            id_: data[i].strUnitId,
            data: {
              // Id: data[i].strUnitId,
              // strFullName: data[i].strFullName,
              // strDate: data[i].strDate,
              // strMobile: data[i].strMobile,
              // strTime: data[i].strTime,
              // strVehicleNo: data[i].strVehicleNo,
              // strMobileType_strComment: data[i].strMobileType_strComment,
              // strJournalType_strComment: data[i].strJournalType_strComment,
              // tiMaxSpeed: data[i].tiMaxSpeed,
              // strComment: data[i].strComment,



              // html: `${data[i].strFullName}`,
            },
          });
          features[i].set("id", i);
        }
        clusterSource.getSource().clear();
        clusterSource.getSource().addFeatures(features);


      }

      // Style for the clusters
      var styleCache = {} as any;
      function getStyle(feature: any, resolution: any) {
        var size = feature.get("features").length;
        var style = styleCache[size];
        if (!style) {
          var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
          var radius = Math.max(8, Math.min(size * 0.75, 20));
          var dash = (2 * Math.PI * radius) / 6;
          var dashs = [0, dash, dash, dash, dash, dash, dash];
          style = styleCache[size] = new Style({
            image: new Circle({
              radius: radius,
              stroke: new Stroke({
                color: "rgba(" + color + ",0.5)",
                width: 15,
                lineDash: dashs,
                lineCap: "butt"
              }),
              fill: new Fill({
                color: "rgba(" + color + ",1)"
              })
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: "#fff"
              })
            })
          });
        }
        return style;
      }

      // Animated cluster layer
      var clusterLayer = new AnimatedCluster({
        name: "Cluster",
        source: clusterSource,
        animationDuration: 700,
        // Cluster style
        style: getStyle
      } as any);
      this.map3.addLayer(clusterLayer);
      // add 2000 features
      addFeatures(2000);

      var style1 = new Style({
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(128,0,0,0.8)",
            width: 2
          }),
          fill: new Fill({
            color: "rgba(128,0,0,0.8)"
          })
        }),
        // Draw a link beetween points (or not)
        stroke: new Stroke({
          color: "#fff",
          width: 1
        })
      });
      // Select interaction to spread cluster out and select features
      var selectCluster = new SelectCluster({
        // Point radius: to calculate distance between the features
        pointRadius: 7,
        animate: true,
        // Feature style when it springs apart
        featureStyle: function () {
          return [style1];
        },
        // selectCluster: false,	// disable cluster selection
        // Style to draw cluster when selected
        style: function (f, res) {
          var cluster = f.get("features");
          if (cluster.length > 1) {
            return getStyle(f, res);
          } else {
            return [
              new Style({
                image: new Circle({
                  stroke: new Stroke({
                    color: "rgba(0,0,192,0.5)",
                    width: 2
                  }),
                  fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                  radius: 5
                })
              })
            ];
          }
        }
      });
      this.map3.addInteraction(selectCluster);
    }, 50);



  }
  getCarTable = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    model.iMobileDomain = this.iMobileDomain;
    model.tiMobileType = this.tiMobileType;
    const resp = await axios.post(`Report_CarMotionless`, model);
    var resPars = JSON.parse(resp.data);
    if (resPars.iResult == 0) {
      this.notifyService.showError(resPars.strError);
      return;

    }
    if (resPars.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '39' } });

      return;
    }
    let arr = resPars;
    for (let index = 0; index < resPars.length; index++) {

      if (((index + 1) % 3 == 0)) {
        index = 0;
        this.tabelArray.push(arr.splice(index, 3));
        if (resPars.length == 1) {
          this.tabelArray.push(arr.splice(index, 1));
          return
        }
        else if (resPars.length == 2) {
          this.tabelArray.push(arr.splice(index, 2));
          return
        }
      }
    }
  }
  showModal = async (data: any) => {
    var model = {
      strUnitID: data.Y,
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      id: this.gurdService.decrypt(window.localStorage.getItem('ID')!)
    }
    const resp = await axios.post(`GetMobileInfo`, model);

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '40' } });

      return;

    }

    $('#carModal').modal('show');
    this.modalData = resp.data;
  }
  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        if (item.featureLayer.feature.values_.features.length == 1) {
          if (item.featureLayer.feature.values_.features[0].values_.data.strFullName) {
            $('#carCluster').modal('show');
            this.clusterModal = item.featureLayer.feature.values_.features[0].values_.data;

          }
        }

        // tooltip
        //   .attr(
        //     'data-bs-original-title',
        //     //item.featureLayer.feature.get('data').html
        //     '<div><h5>hello</h5></div>'
        //   )
        //   .tooltip('show');
        // $("#map-tooltips").click(() => {

        //   this.router.navigate([`/carInfo/${item.featureLayer.feature.get('data').Id}`]);
        //   tooltip.tooltip('hide');

        // });
      }
    } else {
      tooltip.tooltip('hide');
    }
  }
  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
    if (this.iMobileDomain) {
      setTimeout(() => {
        $("#domainDashbord").val(Number(this.iMobileDomain));

      }, 100);
    }
    if (this.tiMobileType) {
      setTimeout(() => {
        $("#carGroup").val(Number(this.tiMobileType));

      }, 100);
    }
  }
  reloadCurrentRoute() {
    let currentUrl = `/detailedDashboard`;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  guid(Id: any) {
    this.otherService.guid(Id);
  }
  carStatus = async (tiChart: any, strValue: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem("ID")!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iMobileDomain: this.iMobileDomain,
      tiMobileType: this.tiMobileType,
      tiChart: tiChart,
      strValue: strValue
    }
    this.otherService.Showspinner();
    const resp = await axios.post(
      `GetMobileListBaseChartStatus`,
      model
    );
    this.otherService.nonespinner();
    $('#CarStatusModal').modal('show');
    this.carStatusData = JSON.parse(resp.data);
  }
  //excel Repotr
  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

}
